import React, { useMemo } from 'react';
// Remove Monaco Editor import
// import Editor from "@monaco-editor/react";
import { PolicyTemplate } from '../../../types/policy';
import { TreeView } from '../../PolicyVisualizer/TreeView/TreeView'; // Import TreeView

/**
 * Props interface for the PreviewSection component
 * @property policy - The current policy template being previewed
 * @property splitPosition - Position of the split between editor and preview (percentage)
 */
interface PreviewSectionProps {
  policy: PolicyTemplate;
  splitPosition: number;
}

/**
 * PreviewSection component for displaying policy JSON preview using TreeView
 * 
 * This component renders the policy using a structured, collapsible TreeView.
 * 
 * @example
 * <PreviewSection
 *   policy={currentPolicy}
 *   splitPosition={70}
 * />
 */
export function PreviewSection({ policy, splitPosition }: PreviewSectionProps) {
  const containerStyle = useMemo(
    () => ({ flex: `0 0 ${100 - splitPosition}%` }),
    [splitPosition]
  );

  return (
    <div
      className="flex flex-col p-3 overflow-hidden bg-white dark:bg-gray-800 text-gray-900 dark:text-white h-full"
      style={containerStyle}
    >
      {/* Render TreeView - clean layout without unnecessary borders */}
      <div className="flex-grow overflow-auto text-2xl min-h-0">
        <TreeView policy={policy} />
      </div>
    </div>
  );
} 